// extracted by mini-css-extract-plugin
export var divider = "_2a-0";
export var dividerText = "_2a-1";